export const HOME = "/";
export const FAQ = "/faq";
export const POLICY = "/policy";
export const ELIGIBLE_PRODUCT = "/eligibleProducts";

export const MY_HR = "https://atoz.amazon.work/myhr";
export const A_TO_Z = "https://hub.amazon.work/home";

export const PLUGFONES_FREE_REIGN_VT_EN_US =
  "https://amazon.plugfones.com/employeesSave/FreeReign";
export const PLUGFONES_FreeReign_VL_FR_CA =
  "https://amazon.plugfones.com/employeesSave/FreeReign/Canada/French";

export const ELGINUSA = "https://elginusa.com/collections/amazon-approved";

export const PLUGFONES_SOVEREIGN_EN =
  "https://amazon.plugfones.com/employeesSave/Sovereign/Canada";
export const PLUGFONES_SOVEREIGN_FR =
  "https://amazon.plugfones.com/employeesSave/Sovereign/French";

  export const PLUGFONES_MERCENARY_LT_EN_US =
  "https://amazon.plugfones.com/employeesSave/Mercenary-Lite";
export const PLUGFONES_MERCENARY_LT_EN_CA =
  "https://amazon.plugfones.com/employeesSave/Mercenary-Lite/Canada";
export const PLUGFONES_MERCENARY_LT_FR_CA =
  "https://amazon.plugfones.com/employeesSave/Mercenary-Lite/Canada/French";
  
export const PLUGFONES_ALLERT_EN_US =
  "https://amazon.plugfones.com/employeesSave/Allert";
export const PLUGFONES_ALLERT_EN_CA =
  "https://amazon.plugfones.com/employeesSave/Allert/Canada";
export const PLUGFONES_ALLERT_FR_VA =
  "https://amazon.plugfones.com/employeesSave/Allert/Canada/French";



export const PLUGFONES_MERCENARY_LT_INDEX = "PLUGFONES_MERCENARY_LT_INDEX";
export const PLUGFONES_ALLERT_INDEX = "PLUGFONES_ALLERT_INDEX";



export const TYPE_PLUGFONE = "PLUGFONE";
export const TYPE_ELGINUSA = "ELGINUSA";

export const HEADPHONE_URL_TO_TYPE_MAP = {
  [PLUGFONES_FREE_REIGN_VT_EN_US]: TYPE_PLUGFONE,
  [ELGINUSA]: TYPE_ELGINUSA,
};

export const prices = {
  [PLUGFONES_FREE_REIGN_VT_EN_US]: {
    originalPriceUSD: "USD $99.95",
    originalPriceCAD: "CAD $132.24",
    priceUSD: "USD $29.99",
    priceCAD: "CAD $40.38",
    discount: "-69%",
  },
  [ELGINUSA]: {
    originalPriceUSD: "USD $59.95",
    originalPriceCAD: "CAD $79.32",
    priceUSD: "USD $49.78",
    priceCAD: "CAD $65.87",
    discount: "-17%",
  },
  [PLUGFONES_SOVEREIGN_EN]: {
    originalPriceUSD: "USD $119.99",
    originalPriceCAD: "CAD $163.98",
    priceUSD: "USD $43.50",
    priceCAD: "CAD $59.45",
    discount: "-63%",
  },
  [PLUGFONES_MERCENARY_LT_INDEX]: {
    originalPriceUSD: "USD $89.99",
    originalPriceCAD: "CAD $121.13",
    priceUSD: "USD $49.99",
    priceCAD: "CAD $67.27",
    discount: "-44%",
  },
  [PLUGFONES_ALLERT_INDEX]: {
    originalPriceUSD: "USD $149.99",
    originalPriceCAD: "CAD $205.99",
    priceUSD: "USD $53.99",
    priceCAD: "CAD $74.66",
    discount: "-64%",
  },
};
